import { api } from './api';
import {
  ApplyConversationLabelsRequest,
  ConversationLabel,
  CreateLabelRequest,
  Label,
  RemoveConversationLabelsRequest,
  UpdateLabelRequest,
} from '../types/label';

class LabelService {
  async getAll(): Promise<Label[]> {
    const response = await api.get<Label[]>('/labels');
    return response.data;
  }

  async getById(id: string): Promise<Label> {
    const response = await api.get<Label>(`/labels/${id}`);
    return response.data;
  }

  async create(data: CreateLabelRequest): Promise<Label> {
    const response = await api.post<Label>('/labels', data);
    return response.data;
  }

  async update(id: string, data: UpdateLabelRequest): Promise<Label> {
    const response = await api.put<Label>(`/labels/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/labels/${id}`);
  }

  async getConversationLabels(conversationId: string): Promise<ConversationLabel[]> {
    const response = await api.get<ConversationLabel[]>(`/conversations/${conversationId}/labels`);
    return response.data;
  }

  async applyToConversation(
    conversationId: string,
    data: ApplyConversationLabelsRequest,
  ): Promise<ConversationLabel[]> {
    const response = await api.post<ConversationLabel[]>(`/conversations/${conversationId}/labels`, data);
    return response.data;
  }

  async removeFromConversation(
    conversationId: string,
    data: RemoveConversationLabelsRequest,
  ): Promise<void> {
    await api.delete(`/conversations/${conversationId}/labels`, { data });
  }
}

export const labelService = new LabelService();
